import type { SliderDesignTokens } from '@primeuix/themes/types/slider'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  range: {
    background: '{primary.color}',
  },
  track: {
    size: '3px',
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
  },
  handle: {
    width: '16px',
    height: '16px',
    content: {
      width: '12px',
      height: '12px',
      shadow: 'none',
      borderRadius: '50%',
      hoverBackground: '{primary.color}',
    },
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    background: '{primary.color}',
    borderRadius: '50%',
    hoverBackground: '{primary.color}',
  },
  colorScheme: {
    dark: {
      handle: {
        content: {
          background: '{surface.950}',
        },
      },
    },
    light: {
      handle: {
        content: {
          background: '{surface.0}',
        },
      },
    },
  },
} satisfies SliderDesignTokens
